module.exports = __webpack_public_path__ + "static/media/Location_Book-Page23.786f8cb8.png";